export default __webpack_public_path__ + "static/tealight-83739fb092e0bfb31496361be6d4dbdb.png";